import UserBaseApi from './base'
import {
  LoginCodeModel,
  LoginStateInfo,
  SendEmailCodeDTO,
  UserModel,
  EmailCodeDTO,
  UserRelationsModel,
  WorkspaceInfoModel,
  WorkspaceMemberModel,
} from './model'
class UserApi extends UserBaseApi {
  // 获取登录二维码
  getLoginCode() {
    return this.get<LoginCodeModel>('/console/authorize/init')
  }
  // 验证登录
  loginVerify(data: string) {
    return this.post<LoginStateInfo>('/console/authorize/verify', data)
  }
  logout() {
    return this.post('/console/authorize/logout')
  }

  getUserRelations() {
    return this.post<UserRelationsModel[]>('/console/user/relations')
  }
  getWorkspaceMember() {
    return this.post<WorkspaceMemberModel>('/console/workspace/member/details')
  }
  getWorkspaceInfo() {
    return this.post<WorkspaceInfoModel>('/console/workspace/info')
  }
  getUserInfo() {
    return this.post<UserModel>('/console/user/info')
  }
  sendEmailCode(dto: SendEmailCodeDTO) {
    return this.post<EmailCodeDTO>('/console/secret/sendEmailCode', dto)
  }
}
export default new UserApi()
